import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'stringDate' })
export class StringDatePipe implements PipeTransform {
  transform(value: any, ...args: any[]) {
    let stringDate = "";
    if(value && value.length>0){
      stringDate = value.substring(0,4)+"-"+value.substring(4,6)+"-"+value.substring(6,8)+" "+value.substring(8,10)+":"+value.substring(10,12)+":"+value.substring(12,14);
    }

    return stringDate;
  }
}



// WEBPACK FOOTER //
// ./src/app/pipe/string_dateFormat.pipe.ts